;(function($) {

	$(document).ready(function() {

		var transitionEndEvent = 'webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionend';
		var downloads_form = $('form#downloads-form');

		if(downloads_form.length) {

			var downloads_button = downloads_form.find('button[type=submit]');
			var select_button = downloads_form.find('button.select-all');
			var checkboxes = downloads_form.find('input[type=checkbox]');

			select_button.text(select_button.data('select-label'));

			select_button.on('click', function() {
				var deselect_class = 'deselect-all';

				if(select_button.hasClass(deselect_class)) {
					select_button.removeClass(deselect_class);
					select_button.text(select_button.data('select-label'));
					checkboxes.attr('checked', false);
				}
				else {
					select_button.addClass(deselect_class);
					select_button.text(select_button.data('deselect-label'));
					checkboxes.attr('checked', true);
				}

				checkboxes.trigger('change');
			});

			checkboxes.on('change', function() {
				var checked = downloads_form.find(':checked').length;

				downloads_button.find('span').text(checked);
				downloads_button.attr('disabled', !(checked > 0));
			});

			downloads_button.on('click', function() {
				$(this).addClass('loading');
			});

			downloads_form.on('submit', function(e) {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();

				downloads_button.attr('disabled', true);

				var data = downloads_form.serializeArray().reduce(function(obj, item) {
					if(obj[item.name]) {
						if(obj[item.name] instanceof Array) {
							obj[item.name].push(item.value);
						}
						else {
							obj[item.name] = [obj[item.name], item.value];
						}
					}
					else {
						obj[item.name] = item.value;
					}
					return obj;
				}, {});

				data['action'] = downloads_params.action;
				data['nonce'] = downloads_params.nonce;

				$.ajax({
					url:      downloads_params.admin_url,
					type:     'POST',
					dataType: 'json',
					data:     data,
					success:  function(response, status, jqXHR) {

						downloads_button.attr('disabled', false);

						downloads_button.addClass('loaded').on(transitionEndEvent, function() {
							var self = $(this);

							self.off(transitionEndEvent);
							self.removeClass('loading loaded');
						});

						if(response.success) {
							window.location = response.data.file_url;
						}
						else {
							console.error(response.data.error);
						}
					}
				});

				return false;
			});
		}
	});

}(jQuery));
